
import { firestore } from "@/firebase";
import { Activity } from "@/types";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { Vue, Component, Prop, VModel, Watch } from "vue-property-decorator";
@Component
export default class ConfirmationDialog extends Vue {
  @Prop({ required: true }) activityId!: string;
  @VModel({ required: true }) show!: boolean;

  activity = null as Activity | null;

  @Watch("show")
  @Watch("activityId")
  async onShowChange() {
    if (this.show && this.activityId && this.activityId !== "") {
      await getDoc(doc(firestore, "activities", this.activityId)).then(
        (doc) => {
          if (doc.exists()) {
            this.activity = {
              id: doc.id,
              ...doc.data(),
            } as Activity;
          } else {
            alert("Activiteit niet gevonden");
          }
        }
      );
      console.log(this.activityId);
    }
  }

  loading = false;
  async save() {
    if (this.activity) {
      this.loading = true;
      await updateDoc(doc(firestore, "activities", this.activity.id!), {
        name: this.activity.name,
        plannedHours: this.activity.plannedHours,
      });
      this.loading = false;
      this.show = false;
      this.$emit("refresh");
    }
  }
}
